// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { MdNotifications } from 'react-icons/lib/md';

import * as notificationActions from '../../../actions/notifications';
import * as closeableActions from '../../../actions/closeable';
import Popup from '../../Popup';
import NotificationPopover from '../../NotificationPopover';
import { ReduxClickPopover } from '../../Closeable';

import NavbarButton from '../NavbarButton';


type NavbarNotificationsPropTypes = {
  count?: number,
  onOpen?: Function,
};

const NOTIFICATION_POPOVER_ID = 'notificationsPopup';

const NavbarNotifications = ({
  count = 0,
  onOpen,
}: NavbarNotificationsPropTypes) => (
  <ReduxClickPopover
    isInline
    id={NOTIFICATION_POPOVER_ID}
    Content={NotificationPopover}
    vertical="below"
    horizontal="middle"
    tipPosition="middle"
    isRound="true"
    isPopover
  >
    <NavbarButton
      Icon={MdNotifications}
      onClick={onOpen}
      badgeCount={count}
    />
  </ReduxClickPopover>
);


export default connect(
  _state => ({
    count: 0,
  }),
  dispatch => ({
    onOpen() {
      dispatch(notificationActions.changePopupScreen(1));
      dispatch(closeableActions.open(NOTIFICATION_POPOVER_ID));
    },
  }),
)(NavbarNotifications);



// WEBPACK FOOTER //
// ./src/scripts/components/Navbar/NavbarNotifications/index.jsx